<app-layout>
  <div class="main">
    <div class="header-table">
      <app-titulo>Parametrização de Notificações</app-titulo>
    </div>

    <div class="grid-outline desktop">
      <div class="grid-header">
        <div class="intern-title">Configuração de E-mails</div>
      </div>

      <app-loader [isLoading]="isLoading"></app-loader>

      <form [formGroup]="form" *ngIf="!isLoading" class="settings-form">

        <div class="setting-row">
          <div class="setting-info">
            <div class="setting-label">Emails de Notificação (Blacklist)</div>
            <div class="setting-desc">
              Emails que receberão alertas de tentativas de operação com veículos/motoristas bloqueados (separe por vírgula).
            </div>
          </div>
          <div class="setting-input-full">
            <textarea
              formControlName="TX_MAIL_NTFC_BLCK"
              class="text-input"
              rows="3"
              placeholder="exemplo@email.com, outro@email.com"
            ></textarea>
          </div>
        </div>

        <div class="form-footer">
          <app-botao
            type="cadastro"
            text="Salvar alterações"
            [disabled]="!form.valid"
            (click)="salvar()">
          </app-botao>
        </div>

      </form>
    </div>
  </div>
</app-layout>
